var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.payment_method.amount)?_c('b-form-select',{staticClass:"m-t-10",attrs:{"options":_vm.get_caja_options(_vm.payment_method.id)},model:{value:(_vm.payment_method.caja_id),callback:function ($$v) {_vm.$set(_vm.payment_method, "caja_id", $$v)},expression:"payment_method.caja_id"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }